import { combineReducers } from 'redux';
import hubUsers from './hubUsers';
import teams from './teams';
import subscriptions from './subscriptions';
import notificationPreferences from './notificationPreferences';
import parentApplication from './parentApplication';
import workflowCreation from './workflowCreation';
import flows from './flows';
import websiteFlows from './websiteFlows';
import formDependencies from './formDependencies';
export default {
  automationTab: combineReducers({
    hubUsers,
    teams,
    subscriptions,
    notificationPreferences,
    parentApplication,
    workflowCreation,
    flows,
    websiteFlows,
    formDependencies
  })
};